

// Column alignment
export const TABLE_COLUMN_ALIGNMENT_LEFT = 'left';
export const TABLE_COLUMN_ALIGNMENT_CENTER = 'center';
export const TABLE_COLUMN_ALIGNMENT_DEFAULT = TABLE_COLUMN_ALIGNMENT_CENTER;